<template>
  <div class="sub-article-list">
    <div class="sub-article" :id="item.id" v-for="(item,index) in this.ARTICLE.subArticles">
      <h2 v-if="item.titlegroup && item.titlegroup.articletitle ">
        <span v-for="titleItem in item.titlegroup.articletitle">
          <component :is="'jo' + item2.name" v-for="item2 in titleItem.data" v-bind:key="item2.index"
                     v-bind:data="item2.data"></component>
        </span>
      </h2>
      <div class="sub-content">
        <component :is="'jo' + item1.name" v-for="item1 in item.body" v-bind:key="item1.index"
                   v-bind:data="item1.data"></component>
      </div>
      <div class="sub-source">
        <span>源自：</span><i v-for="sourceItem in item.source">
        <component :is="'jo' + item1.name" v-for="item1 in sourceItem" v-bind:key="item1.index"
                   v-bind:data="item1.data"></component>
      </i>
      </div>
    </div>
  </div>
</template>

<script>
  import jofig from '../components/maincontent/body/fig/fig.vue'
  import jodispformula from '../components/maincontent/body/formula/dispformula.vue'
  import jotable from '../components/maincontent/body/table/table.vue'
  import jofiggroup from '../components/maincontent/body/fig/figgroup.vue'
  export default{
    components: {
      jofig,
      jodispformula,
      jotable,
      jofiggroup
    },
    data() {
      return {}
    },
    created() {
    }
  }
</script>

<style lang="scss" scoped>
.sub-article-list{
  .sub-source{
    p{
      display: inline;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/commonComponents/subArticle.vue